/* eslint-disable no-unused-vars */
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import { useState } from 'react';
import { color } from '../../app/theme';
import Button from './Button';

const useStyles = makeStyles(
  {
    root: {
      position: 'relative',
    },
    menu: {
      position: 'absolute',
      top: 48,
      left: 0,
      right: 0,
      zIndex: 3,
      backgroundColor: `${color.$7}`,
      boxShadow:
        '0 16px 48px 0 rgba(0, 0, 0, 0.07), 0 6px 18px 0 rgba(0, 0, 0, 0.03)',
      borderRadius: '12px',
      padding: '8px 0',
      margin: 0,
      listStyle: 'none',
      maxHeight: '294px',
      overflowY: 'auto',
    },
    item: {
      display: 'flex',
      height: '44px',
      flexWrap: 'wrap',
      alignItems: 'center',
      padding: '0 24px',
      cursor: 'pointer',
      fontSize: '13px',
      lineHeight: '13px',
      color: color.$13,
      '& > div': {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        display: 'flex',
        alignItems: 'center',
        '& > img': {
          marginRight: 8,
        },
      },
      '&:hover': {
        color: `${color.$2}`,
      },
    },
  },
  {
    name: 'DropdownButton',
  },
);

/**
 *
 * @param {item} icon, iconHover, text, onClick
 * @returns
 */

const Item = ({ item, onClickAway }) => {
  const classes = useStyles();
  const [isHoverd, setIsHovered] = useState(false);

  return (
    <li
      className={classnames(classes.item)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => {
        if (item?.onClick) item?.onClick(item);
        onClickAway(false);
      }}
    >
      <div>
        {item?.icon && item?.iconHover && (
          <img
            alt="icon"
            className={classes.startIcon}
            src={isHoverd ? item?.iconHover : item?.icon}
          />
        )}
        {item.text}
      </div>
    </li>
  );
};

const DropdownButton = ({ buttonText, menuItems }) => {
  const classes = useStyles();
  const [isShow, setIsShow] = useState(false);

  const menuItemComponents = menuItems.map(item => {
    return (
      <Item
        key={`menuItemComponents-${item?.text}`}
        item={item}
        onClickAway={() => setIsShow(false)}
      />
    );
  });

  return (
    <ClickAwayListener onClickAway={() => setIsShow(false)}>
      <div className={classes.root}>
        <Button topic="primaryBlue" onClick={() => setIsShow(true)}>
          {buttonText}
        </Button>
        {isShow && <ul className={classes.menu}>{menuItemComponents}</ul>}
      </div>
    </ClickAwayListener>
  );
};

export default DropdownButton;
